import { useContext } from 'react'
import { PropertyDataContext } from '../context/PropertyDataContext.js'

export const usePropertyData = () => useContext(PropertyDataContext)
